/**
 * Constants for the Pagos indicators panel (TOM-388)
 */

export const INDICADORES_PAGOS_CONSTANTS = {
    /**
     * Corte cutoff hours — Finanzas processes validations in two daily batches
     */
    CORTE_HOURS: {
        CORTE_1: 10,
        CORTE_2: 17
    },

    /**
     * Business-hours window for the elapsed-time average (Mon-Fri only, see esDiaInhabilMx)
     */
    BUSINESS_HOURS: {
        START_HOUR: 8,
        END_HOUR: 18
    },

    /**
     * Forma de pago grid, 4 rows of 5, in the exact order Finanzas asked for. `null` cells are
     * blank fillers to complete the last row. Values use the real casing stored in RTDB
     * catalogos/formasDePago (confirmed live) — NOT title case.
     */
    FORMAS_DE_PAGO_GRID: [
        ['Transferencia', 'Depósito Bancario', 'Link BBVA', 'Terminal AMEX', 'Oxxo'],
        ['Efectivo', 'Efectivo Operador', 'PayPal', 'Cheque', 'Experiencias'],
        ['Orden de compra', 'Bono - Autorización directiva', 'Interno', 'Convenio - Patrocinio', 'Descuento Vía Nómina'],
        ['Bono Calidad', 'Saldo a Favor', null, null, null]
    ],

    /**
     * Colour ramp for the corte-slippage buckets (green → red)
     */
    CORTE_BUCKET_COLORS: {
        anticipado: 'green',
        enSuCorte: 'green',
        mas1: 'darkgoldenrod',
        mas2: 'orange',
        mas3: 'red'
    }
};



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/finanzas/components/pagos/indicadores-pagos.constants.ts